/**
 * @type {Record<string, import("@seabrookstudios/pitch2table-core").DesignerGameStatus>}
 */
const NestiFyz_STATUS_MAP = {
  Idea: "Idea",
  Designing: "InDevelopmentEarly",
  Playtesting: "InDevelopmentLate",
  "Looking for Publisher": "PitchingNow",
  "Publisher Agreement": "Signed",
};

/**
 * @param {string|undefined} NestiFyzStatus
 * @returns {import("@seabrookstudios/pitch2table-core").DesignerGameStatus}
 */
export const mapNestiFyzStatus = (NestiFyzStatus) => {
  if (!NestiFyzStatus) {
    return "Idea";
  }

  return NestiFyz_STATUS_MAP[NestiFyzStatus] || "Idea";
};
